import { render, staticRenderFns } from "./leimu.vue?vue&type=template&id=8d240aac&scoped=true&"
import script from "./leimu.vue?vue&type=script&lang=js&"
export * from "./leimu.vue?vue&type=script&lang=js&"
import style0 from "./leimu.vue?vue&type=style&index=0&id=8d240aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d240aac",
  null
  
)

export default component.exports